import { client, getUrl } from "../../../../utils";

export const getUsersRequest = (filterParams) => client.get(getUrl("users", filterParams));

export const createUserRequest = (data) => client.post("users", data);

export const getUserRequest = (id) => client.get(`user/${id}`);

export const updateUserRequest = (data) => client.put(`user/${data.id}`, data);

export const deleteUserRequest = (id) => client.delete(`user/${id}`);
